export const Gender = {
    MALE: '男',
    FEMALE: '女',
};

export const PiIdentity = {
    PI: 'PI',
    SUB_1: 'Sub-I',
    Research_nurse: '研究护士',
    Others: '其他(药师、技师等)',
};


// WEBPACK FOOTER //
// ./src/components/site/piInfo/constants.js